<template>
  <div class="page flex-col">
    <!-- 右上角售后申请按钮 -->
    <div class="after-sales-btn" @click="goToAfterSales">
      <span>售后申请</span>
    </div>
    <!-- <div class="text-wrapper_1 flex-row">
      <span class="text_2">绑定设备</span>
    </div> -->
    <div class="group_2 flex-row">
      <div class="image-text_1 flex-col">
        <div class="image-wrapper_1 flex-col">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./img/1.png"
          />
        </div>
        <div class="text-group_1 flex-col">
          <span class="text_3">您尚未绑定任何设备</span>
          <span class="text_4">点击下方按钮扫描绑定设备</span>
        </div>
      </div>
    </div>
    <div class="group_3 flex-row">
      <div class="box_1 flex-row">
        <div class="image-text_2 flex-row justify-between">
          <img
            class="label_1"
            referrerpolicy="no-referrer"
            src="./img/2.png"
          />
          <span class="text-group_2" @click="binding()">扫码绑定设备</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { binddevice,health } from '@/api/activity'
import { mapState, mapActions } from 'pinia';
import { useUserStore } from '@/stores/user';
export default {
  data() {
    return {
      constants: {},
      name:''
    };
  },
  computed: {
    ...mapState(useUserStore, ['userInfo'])
  },
  mounted() {
    console.log(this.userInfo)
    document.title = '绑定设备';
    window.bindDevice = this.bindDevice
    // this.bindDevice('{"IMEI":"IMEI:366414620832551","MAC":"MAC:50:C0:F0:14:BA:F5","ICCID":"ICCID:898604A7182420006652","NAME":"BRS-W64"}')
  },
  methods: {
    cleanJsonString(jsonStr) {
    // 使用正则表达式移除控制字符
    return jsonStr.replace(/[\x00-\x1F\x7F]/g, '');
     },
    bindDevice(str) {
      console.log(str,'61行，二维码扫码数据')
      // console.log(JSON.parse(this.cleanJsonString(str)).MAC.slice(4, 5 + 17),'二维码数据')
      // if (this.$env.inAndroid) {
      // var obj = {
      //   bindStatus:'02',
      //   deviceCode:JSON.parse(this.cleanJsonString(str)).IMEI.slice(5, 6 + 15),
      //   mac:JSON.parse(this.cleanJsonString(str)).MAC.slice(4, 5 + 17),
      //   devModel:JSON.parse(this.cleanJsonString(str)).NAME.slice(5, 6 + 7),
      //   iccid:JSON.parse(this.cleanJsonString(str)).ICCID.slice(6, 6 + 20),
      //   deviceType:''
      // }
      // if(JSON.parse(this.cleanJsonString(str)).ICCID == '') {
      //   obj.deviceType = 10010001
      // }else {
      //   obj.deviceType = JSON.parse(this.cleanJsonString(str)).NAME
      //   // JSON.parse(this.cleanJsonString(str)).NAME.slice(5, 6 + 7)
      // }
      // } else if (this.$env.inIos) {
      //   var obj = {
      //   bindStatus:'02',
      //   deviceCode:JSON.parse(this.cleanJsonString(str)).IMEI,
      //   mac:JSON.parse(this.cleanJsonString(str)).MAC,
      //   devModel:JSON.parse(this.cleanJsonString(str)).NAME,
      //   iccid:JSON.parse(this.cleanJsonString(str)).ICCID,
      //   deviceType:''
      // }
      // if(JSON.parse(this.cleanJsonString(str)).ICCID == '') {
      //   obj.deviceType = 10010001
      // }else {
      //   obj.deviceType = JSON.parse(this.cleanJsonString(str)).NAME
      // }
      // }
      var obj = {
        deviceCode:'',
        deviceType:'',
        bindStatus:'02',
        jsonBrs:str
      }
      binddevice(obj).then((res)=>{
        if(res.code == 1000) {
          this.$message({
            type: "success",
            message: "绑定成功!",
          });
          this.setUserInfo({
          id:this.userInfo.id,
          name:this.userInfo.name,
          userCode:this.userInfo.userCode,
          idNo:this.userInfo.idNo,
          avatar:this.userInfo.avatar,
          age:this.userInfo.age,
          sex:this.userInfo.sex,
          userPhone:this.userInfo.userPhone,
          token:this.userInfo.token,
          refreshToken:this.userInfo.refreshToken,
          isBinding:true
        });
        this.$router.replace({ path: '/unbind' });
          // this.$router.push({
          //     path: "/unbind",
          //     query:{
          //     }
          //   });
        }
      })
    },
    extractDataAfterString(str, search) {
      if (str.includes(search)) {
        const parts = str.split(search);
        // 返回后边的数据，如果有多个search，返回最后一个search后的数据
        return parts.length > 1 ? parts.pop() : '';
      }
      return ''; // 如果不包含，返回空字符串
    },
    binding() {
      health().then((res)=>{
        if (res.code == 1000) {
         if(res.data.height != null && res.data.weight != null) {
          if (this.$env.inDjxApp){
            if (this.$env.inAndroid){
              JSInterface.actionScanCode()
            }else if (this.$env.inIos) {
              window.webkit.messageHandlers.actionScanCode.postMessage(null);
            }
          }
         }else {
          this.$message.error('请填写个人信息');
          this.$router.push({
              path: "/information",
              query:{
              }
            });
         }
         
        }
      })
      
      
    },
    goToAfterSales() {
      this.$router.push({
        path: "/afterSales"
      });
    },
    ...mapActions(useUserStore, ['setUserInfo'])
  },
  activated() {
  },
};
</script>
<style scoped>
.page {
  background-color: rgba(242, 243, 245, 1);
  position: relative;
  width: 375px;
  height: 812px;
  overflow: hidden;
  padding: 14px 14px 318px 16px;
}

.group_1 {
  margin-left: 5px;
}

.text_1 {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 15px;
  letter-spacing: -0.30000001192092896px;
  font-family: SFProText-Semibold;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_1 {
  width: 17px;
  height: 11px;
  margin: 4px 0 3px 219px;
}

.thumbnail_2 {
  width: 15px;
  height: 11px;
  margin: 3px 0 4px 5px;
}

.image_1 {
  width: 25px;
  height: 12px;
  margin: 3px 0 3px 5px;
}

.text-wrapper_1 {
  margin: 26px 249px 0 0;
}

.text_2 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
  white-space: nowrap;
  line-height: 33px;
}

.group_2 {
  width: 168px;
  align-self: center;
  margin:0 auto;
  margin-top: 142px;
}

.image-text_1 {
}

.image-wrapper_1 {
  /* background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng85184771c522cf25cd6ce5452c0f9b9f1937bdeb3831cce0dbc23d4c9faadd1c) */
    /* 100% no-repeat; */
  background-size: 100% 100%;
  align-self: center;
  width: 72px;
  height: 72px;
  margin: 0 auto;
  /* padding: 9px 23px 9px 22px; */
}

.image_2 {
  width: 72px;
  height: 72px;
}

.text-group_1 {
  margin-top: 16px;
}

.text_3 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
  white-space: nowrap;
  line-height: 25px;
  align-self: center;
}

.text_4 {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 16px;
}

.group_3 {
  width: 196px;
  align-self: center;

  margin: 0 auto;
  margin-top: 72px;
}

.box_1 {
  background-color: rgba(0, 187, 130, 1);
  border-radius: 4px;
  padding: 8px 40px 8px 40px;
}

.image-text_2 {
  width: 116px;
  display: flex;
    justify-content: center;
    align-items: center;
}

.label_1 {
  width: 24px;
  height: 24px;
}

.text-group_2 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.after-sales-btn {
  position: absolute;
  top: 20px;
  right: 16px;
  background-color: rgba(0, 187, 130, 1);
  border-radius: 16px;
  padding: 8px 16px;
  cursor: pointer;
  z-index: 999;
  transition: all 0.3s ease;
}

.after-sales-btn:hover {
  background-color: rgba(0, 167, 115, 1);
}

.after-sales-btn span {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/views/binding/index.vue